import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const CountryOfResidencePopup = ({ selectedCountry, loginCountryId, residenceCountryId, popupRef = null, closeDropbox, text }) => {
    const messages = usePageMessages();
    const resCountryId = parseInt(residenceCountryId);

    const residenceLocalizedCountry = `specialResidentCountry${resCountryId}`;
    const loginLocalizedCountry = `specialResidentCountry${loginCountryId}`;
    const popupResidenceCountry = messages[residenceLocalizedCountry];
    const popupLoginCountry = messages[loginLocalizedCountry];

    const getText = (homeland, otherCountry) => {
        let text;
        let args;
        if (String(selectedCountry) === String(loginCountryId)) {
            text = homeland;
            args = popupLoginCountry;
        } else {
            text = otherCountry;
            args = [popupResidenceCountry, popupLoginCountry];
        }
        return <DangerouslyHtml dangerouslyHtml={resolveArguments(text, args)} />;
    };

    const onClick = () => {
        if (popupRef?.current) {
            popupRef.current?.close();
        }
        closeDropbox();
    };

    return (
        <SimplePopup text={text || getText(messages.homelandPopup, messages.otherCountryPopup)} popupRef={popupRef}>
            <PopupButton iconName="check" text={messages.gotIt} onClick={onClick} />
        </SimplePopup>
    );
};

export default CountryOfResidencePopup;

CountryOfResidencePopup.propTypes = {
    onClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
